import { render, staticRenderFns } from "./HospitalIntroXianTangdu.vue?vue&type=template&id=c7b22362&scoped=true"
import script from "./HospitalIntroXianTangdu.vue?vue&type=script&lang=js"
export * from "./HospitalIntroXianTangdu.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroXianTangdu.vue?vue&type=style&index=0&id=c7b22362&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b22362",
  null
  
)

export default component.exports